import Grid from '@blocks/Grid'
import Slider from '@blocks/Slider'
import { colors } from '@styles/vars'
import React from 'react'
import styled from 'styled-components'

export default function AcceptanceSlider({ item: nomination, gallery }: Props) {
    return (
        <Slider src={nomination.photo.url} gallery={gallery}>
            <Content>
                <Grid gap="5px">
                    <h3>{nomination.photo.title}</h3>
                    <Original>Original: <a href={nomination.photo.url} target="_blank">{nomination.photo.width}x{nomination.photo.height}</a></Original>
                </Grid>
            </Content>
        </Slider>
    )
}

interface Props {
    item: Jury.Resources.Acceptance
    gallery: Interfaces.Gallery
}

// STYLES
const Original = styled.small`
    opacity: .8;
`

const Content = styled.div`
    h4, a, small, button, p {
        color: ${colors.white};
    }

    svg {
        fill: ${colors.white};
    }
`